var map = {
	"./assets/READMEs/DevLab.md": 527,
	"./assets/READMEs/Finesse.md": 528,
	"./assets/READMEs/MPratings.md": 529,
	"./assets/READMEs/MtSutro.md": 530,
	"./assets/READMEs/PetPackage.md": 531,
	"./assets/READMEs/RapGod.md": 532,
	"./assets/READMEs/Tempo.md": 533,
	"./assets/audio/sayuwont.mp3": 534,
	"./assets/css/reset.css": 535,
	"./assets/images/Bamazon.gif": 536,
	"./assets/images/DevLab.gif": 537,
	"./assets/images/DevLab.png": 538,
	"./assets/images/Finesse.PNG": 539,
	"./assets/images/Head.jpg": 540,
	"./assets/images/Liri Spotify.PNG": 541,
	"./assets/images/Liri.gif": 542,
	"./assets/images/MPratings.png": 543,
	"./assets/images/MtSutro.gif": 544,
	"./assets/images/MtSutro.png": 545,
	"./assets/images/Pet Package.png": 546,
	"./assets/images/RapGod.JPG": 547,
	"./assets/images/SM.png": 548,
	"./assets/images/Tempo.gif": 549,
	"./assets/images/Zelda.png": 550,
	"./assets/images/box-logo.png": 551,
	"./assets/images/friendfinder.gif": 552,
	"./assets/images/mealpal.gif": 553,
	"./assets/images/pinkyellowgradient.jpg": 554,
	"./assets/js/fireworks": 163,
	"./assets/js/fireworks.js": 163,
	"./favicon.ico": 555,
	"./index.html": 556,
	"./manifest": 164,
	"./manifest.json": 164
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 526;